import DailyFrame from "./DailyFrame";

export default DailyFrame;
